"use client";

import React from "react";
import {
	MOVE_BRASIL_STEPS,
	MOVE_BRASIL_STEPS_START_DATE,
} from "@/app/config/moveBrasilSteps";
import styles from "@/styles/move-brasil.module.scss";

function formatStepDescription(
	description: string,
	boldParts: readonly string[],
): React.ReactNode {
	return boldParts.reduce<React.ReactNode[]>(
		(chunks, part, partIndex) =>
			chunks.flatMap((chunk, chunkIndex) => {
				if (typeof chunk !== "string") return [chunk];
				const bits = chunk.split(part);
				if (bits.length === 1) return [chunk];
				return bits.flatMap((bit, bitIndex) => {
					const nodes: React.ReactNode[] = [];
					if (bit) nodes.push(bit);
					if (bitIndex < bits.length - 1) {
						nodes.push(
							<strong key={`${partIndex}-${chunkIndex}-${bitIndex}`}>
								{part}
							</strong>,
						);
					}
					return nodes;
				});
			}),
		[description],
	);
}

export const HowItWorksSection: React.FC = () => {
	return (
		<section className={styles.howItWorks}>
			<h2 className={styles.howItWorksTitle}>
				Como funciona -{" "}
				<span className={styles.howItWorksTitleHighlight}>
					Passo a passo
				</span>
			</h2>

			<p className={styles.howItWorksSubtitle}>
				Programa com início a partir de{" "}
				<strong>{MOVE_BRASIL_STEPS_START_DATE}</strong>
			</p>

			<div className={styles.howItWorksGrid}>
				{MOVE_BRASIL_STEPS.map((step) => (
					<article key={step.title} className={styles.stepCard}>
						<h3 className={styles.stepCardTitle}>{step.title}</h3>
						<p className={styles.stepCardText}>
							{formatStepDescription(
								step.description,
								step.boldParts,
							)}
						</p>
					</article>
				))}
			</div>
		</section>
	);
};
